module.exports = __webpack_public_path__ + "static/media/Image 13@2x.1f3d03a7.png";